import { createUserWithEmailAndPassword, getAuth, sendEmailVerification, signInWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, getFirestore, setDoc } from 'firebase/firestore';
import { useState } from 'react';
import { app } from '../firebase';
import { buildUserProfileDocument } from '../utils/profileDefaults';
import './AuthForm.css';

const auth = getAuth(app);
const db = getFirestore(app);

const AuthForm = ({ onAuthSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [name, setName] = useState('');
    const [username, setUsername] = useState('');
    const [isSignup, setIsSignup] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            if (isSignup) {
                const cleanUsername = username
                    .toLowerCase()
                    .trim()
                    .replace(/[^a-z0-9]+/g, '-')
                    .replace(/^-+|-+$/g, '');
                const displayName = name.trim() || cleanUsername;

                if (password !== confirmPassword) {
                    setError('Passwords do not match.');
                    setLoading(false);
                    return;
                }
                if (!cleanUsername) {
                    setError('Public username is required.');
                    setLoading(false);
                    return;
                }
                if (cleanUsername.length < 3) {
                    setError('Username must be at least 3 characters.');
                    setLoading(false);
                    return;
                }
                const userCredential = await createUserWithEmailAndPassword(auth, email, password);
                await sendEmailVerification(userCredential.user);
                await updateProfile(userCredential.user, { displayName });
                // Create Firestore profile document on signup
                await setDoc(
                    doc(db, 'profiles', userCredential.user.uid),
                    buildUserProfileDocument({
                        user: userCredential.user,
                        name: displayName,
                        username: cleanUsername,
                    }),
                    { merge: true }
                );
                alert('Verification email sent! Please check your inbox.');
            } else {
                await signInWithEmailAndPassword(auth, email, password);
            }
            if (onAuthSuccess) onAuthSuccess();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-form-container">
            <form className="auth-form" onSubmit={handleSubmit}>
                <h2>{isSignup ? 'Sign Up' : 'Log In'}</h2>
                {error && <div className="auth-error">{error}</div>}
                {isSignup && (
                    <>
                        <input
                            type="text"
                            placeholder="Public username"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            required
                            minLength={3}
                            autoComplete="username"
                        />
                        <input
                            type="text"
                            placeholder="Display name"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            autoComplete="name"
                        />
                    </>
                )}
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                />
                {isSignup && (
                    <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        required
                    />
                )}
                <button type="submit" disabled={loading}>
                    {loading ? (isSignup ? 'Signing Up...' : 'Logging In...') : (isSignup ? 'Sign Up' : 'Log In')}
                </button>
                <p>
                    {isSignup ? 'Already have an account?' : "Don't have an account?"}
                    <button type="button" className="switch-btn" onClick={() => setIsSignup(!isSignup)}>
                        {isSignup ? 'Log In' : 'Sign Up'}
                    </button>
                </p>
            </form>
        </div>
    );
};

export default AuthForm;
